import React from 'react';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';

import Modal from 'react-modal';
import { styledTheme } from 'globalStyles/theme';
import './styles.scss';

const ConfirmModal = ({
  open,
  onClose,
  children,
  modalName = 'thanks',
  header = false,
}) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={open}
      contentLabel="PodoModal"
      className={`invoice-modal--confirm invoice-modal--${modalName}`}
      shouldCloseOnOverlayClick
      onRequestClose={onClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
          backgroundColor: styledTheme.modalBackground,
        },
      }}
    >
      {header &&
        (
          <>
            <div
              className="invoice-modal__header"
            >
              <IoClose
                className="invoice-modal__close"
                size={20}
                onClick={onClose}
              />
            </div>
          </>
        )
      }
      <div className="invoice-modal__body">
        {children}
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

ConfirmModal.defaultProps = {
  open: true,
  onClose: () => {},
};

export default ConfirmModal;
